import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { AuthService } from '@services/auth';
import { FeaturesService } from '@services/features';
import { ErrorInterceptor, FakeBackendInterceptor, LoaderInterceptor } from '@interceptors';
import { Feature } from '@enums';
export var http = axios.create({
  baseURL: process.env.baseUrl,
  headers: {
    'Content-type': 'application/json'
  },
  errorRedirect: true
});

if (FeaturesService.available(Feature.MockAPI)) {
  var mockAdapter = new MockAdapter(http, {
    delayResponse: 1000
  });
  FakeBackendInterceptor(mockAdapter);
}

http.interceptors.request.use(function (request) {
  var token = AuthService.getTokenLocalStorage();

  if (request && request.headers && token && !request.anonymousRequest) {
    request.headers.Authorization = token ? "Bearer ".concat(token) : false;
  }

  return request;
});
http.interceptors.request.use(function (request) {
  return LoaderInterceptor({
    request: request
  });
}, function (error) {
  return LoaderInterceptor({
    error: error
  });
});
http.interceptors.response.use(function (response) {
  return LoaderInterceptor({
    response: response
  });
}, function (error) {
  return LoaderInterceptor({
    error: error
  });
});
http.interceptors.request.use(function (request) {
  return request;
}, ErrorInterceptor);
http.interceptors.response.use(function (response) {
  return response;
}, ErrorInterceptor);

var ApiServiceClass = /*#__PURE__*/function () {
  function ApiServiceClass() {
    _classCallCheck(this, ApiServiceClass);
  }

  _createClass(ApiServiceClass, [{
    key: "apiGet",
    value: function () {
      var _apiGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, props) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http.get(path, props);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiGet(_x, _x2) {
        return _apiGet.apply(this, arguments);
      }

      return apiGet;
    }()
  }, {
    key: "apiPost",
    value: function () {
      var _apiPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, body, props) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return http.post(path, body, props);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiPost(_x3, _x4, _x5) {
        return _apiPost.apply(this, arguments);
      }

      return apiPost;
    }()
  }, {
    key: "apiPut",
    value: function () {
      var _apiPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, body, props) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return http.put(path, body, props);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function apiPut(_x6, _x7, _x8) {
        return _apiPut.apply(this, arguments);
      }

      return apiPut;
    }()
  }, {
    key: "apiDelete",
    value: function () {
      var _apiDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, body, props) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return http["delete"](path, _objectSpread(_objectSpread({}, body && {
                  data: body
                }), props));

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function apiDelete(_x9, _x10, _x11) {
        return _apiDelete.apply(this, arguments);
      }

      return apiDelete;
    }()
  }, {
    key: "apiPatch",
    value: function () {
      var _apiPatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, body, props) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return http.patch(path, body, props);

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function apiPatch(_x12, _x13, _x14) {
        return _apiPatch.apply(this, arguments);
      }

      return apiPatch;
    }()
  }]);

  return ApiServiceClass;
}();

var ApiService = new ApiServiceClass();
export { ApiService };